// 통계 API — 백엔드 kr.taplink.stats.StatsController
// 타입은 OpenAPI 계약에서 생성(DSN-3)
import type { Schemas } from "@taplink/api-client";
import { request } from "@taplink/web-shared";

/** date는 ISO(yyyy-MM-dd) */
export type DailyPoint = Schemas["DailyPoint"];
/** retentionDays null = 무제한 · truncated = 요청 기간이 요금제 보관 한도에 걸려 잘렸는지 */
export type StatsRange = Schemas["StatsRange"];
export type TopLink = Schemas["TopLink"];
export type StatsSummary = Schemas["StatsSummary"];
export type LinkStats = Schemas["LinkStats"];

const range = (from?: string, to?: string) => {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const query = params.toString();
  return query ? `?${query}` : "";
};

export const statsApi = {
  summary: (from?: string, to?: string, top = 5) => {
    const params = new URLSearchParams({ top: String(top) });
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    return request<StatsSummary>(`/stats/summary?${params.toString()}`);
  },

  link: (shortKey: string, from?: string, to?: string) =>
    request<LinkStats>(`/short-urls/${shortKey}/stats${range(from, to)}`),
};

/** yyyy-MM-dd (로컬 기준) — 서버도 Asia/Seoul 기준으로 하루를 자른다 */
export function isoDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function daysAgo(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return isoDate(d);
}

/**
 * 축 눈금용 '깔끔한' 상한.
 *
 * 1/2/5 배수만 쓰면 최댓값 23에 상한 50이 잡혀 가장 높은 막대가 플롯의 절반도 못 채운다.
 * 눈금이 반으로 나눠도 정수로 떨어지는 배수만 골라 촘촘하게 둔다.
 */
export function niceCeiling(max: number): number {
  // 클릭이 하나도 없는 경우 — 상한 1이면 중간 눈금이 0.5가 되어 축에 소수점이 뜬다
  if (max <= 0) return 2;
  const magnitude = 10 ** Math.floor(Math.log10(max));
  for (const step of [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) {
    const candidate = step * magnitude;
    // 중간 눈금(상한/2)도 정수여야 축에 소수점이 나오지 않는다
    if (max <= candidate && Number.isInteger(candidate / 2)) return candidate;
  }
  return 10 * magnitude;
}
